export var createHandlerProxy = function (handlerMap) {
    return (function (name) { return function (event) {
        var handler = handlerMap[name] || (function (event) { });
        handler(event);
    }; });
};
